/**
 * SpringBoneCollisionPlane3D registration: the parser. It reuses the Node3D parse, and
 * linterParser.ts holds the property knowledge. SpringBoneCollisionPlane3D's Godot effect is
 * not implemented here yet (ADR-0045), so index.r3f.ts registers Node3D as `pending` to keep
 * its children in the right transform space.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseNode3D } from '../../../base/node3d/parser';
const springBoneCollisionPlane3DRegistration = {
    typeName: 'SpringBoneCollisionPlane3D',
    parser: parseNode3D,
};
nodeRegistry.register(springBoneCollisionPlane3DRegistration);
//# sourceMappingURL=index.js.map